import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { ApiService } from './../../shared/services/api.service';
import { FormControlService } from './../../shared/services/form-control.service';
import { AlertService } from './../../shared/services/alert.service';
import { FormDetailBase } from './../../shared/components/base/form-detail/form-detail.base.component';
import { EntityService } from './../../shared/services/entity.service';
import { Storyboard } from './../../models/storyboards/storyboards.model';
import { Textbox } from './../../models/editors/textbox.model';
import { ContainedMany } from './../../models/editors/contained-many.model';
import { atLeastOneLang } from './../../shared/validators/langField.validator';
import { Switch } from './../../models/editors/switch.model';

@Component({
  selector: 'swb-storyboard-detail',
  templateUrl: './../../shared/components/base/form-detail/form-detail.base.component.html',
  providers: [FormControlService]
})
export class StoryboardDetailComponent extends FormDetailBase<Storyboard> implements OnInit {
  public url = 'storyboards';
  protected _redirect = './pages';

  public entity = new Storyboard({});

  public get fieldsConfig(): Array<any> {
    return [
      new Textbox({
        key: 'title',
        label: 'Název',
        isMultilang: true,
        validators: [atLeastOneLang]
      }),
      new Switch({
        key: 'show_title',
        label: 'Zobrazovat titulek',
        defaultValue: true
      }),
      new ContainedMany({
        key: 'files',
        label: 'Obrázky',
        imgOnly: true,
        upload: true,
        apiUrl: 'files'
      })
    ];
  }

  constructor(
    _formService: FormControlService,
    _apiService: ApiService,
    _router: Router,
    _alertService: AlertService,
    private _route: ActivatedRoute,
    private _entityService: EntityService
  ) {
    super(
      _formService,
      _apiService,
      _router,
      _alertService
    );
  }

  ngOnInit() {
    if (typeof this._route.snapshot.params['id'] !== 'undefined') {
      this._id = this._route.snapshot.params['id'];
    }

    if (this._route.outlet === 'modal-form') {
      this.isModal = true;
      this._redirect = undefined;
      this._saveCallback = this._saveCallback = (response) => {
        const item = { ...response }.data;
        this._entityService.setChosenEntities([item], 'storyboards');
        this._closeCallback();
      };
      this._closeCallback = () => {
        this._router.navigate([{ outlets: { 'modal-form': null } }], {
          relativeTo: this._route.parent
        });
      };
      this._id = undefined; // TODO: better?
      window.scrollTo(0, 0);
    }

    this._getEntity();

  }

}
